// Wrapper to safely handle Supabase client initialization
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Lovable Cloud - Supabase credentials (public values, safe to include)
// These are automatically provided by environment variables, with fallbacks
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || 'https://zxkekzhreygcfyfqkkqp.supabase.co';
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp4a2VremhyZXlnY2Z5ZnFra3FwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjIzMDAyNDMsImV4cCI6MjA3Nzg3NjI0M30.4MgunLleeubxikU1HSOwADvrFb8e7QAdhiDAlsLyU3A';

// Create Supabase client (these are public credentials, safe for client-side use)
export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});

// Helper to check if Supabase is available
export const isSupabaseAvailable = () => !!supabase;
